const mandatoryMhexpatOptions = new Set([
  'PRD_MANDATAIRE',
  'PRD_MONDEXPAT',
  'PRD_FRANCEEXPAT',
  'PRD_RETRAITEXPAT',
  'ASSISTANCE_CFE_SENIOR',
  'ASSISTANCE_CFE',
  'ASSISTANCE'
]);

const isMandatorySupplementaryCover = (code) => mandatoryMhexpatOptions.has(code);

export default isMandatorySupplementaryCover;
